import React from "react";

export default (props) => {
  const item = props;
  let content;

  if (item.data.Season == "PM") {
    if (item.data.Complete == 3) {
      content = (
        <div class="gray">
          <div class="dash"></div>
        </div>
      );
    } else if (item.data.Complete == 4) {
      content = <div class="bluecircle"></div>;
    } else if (item.data.Complete == 2) {
      content = <div class="green">✔</div>;
    } else if (item.data.Complete == 1) {
      content = <div class="yellow"></div>;
    } else if (
      item.data.Complete == 4 &&
      item.data.InSeason == "Yes" &&
      item.data.BMPM == "Math Fluency PM"
    ) {
      content = <div class="blue"></div>;
    } else if (
      item.data.Complete == null &&
      item.data.InSeason == "No" &&
      item.data.BMPM == "Math Fluency PM"
    ) {
      content = (
        <div class="gray">
          <div class="dash"></div>
        </div>
      );
    } else {
      content = (
        <div class="gray">
          <div class="dash"></div>
        </div>
      );
    }
  } else {
    if (item.data.Complete == 2) {
      content = <div class="green">✔</div>;
    } else if (item.data.Complete == 1) {
      content = <div class="yellow"></div>;
    } else {
      content = (
        <div class="gray">
          <div class="dash"></div>
        </div>
      );
    }
  }
  return <div className="lionStatus">{content}</div>;
};
